import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export class ReminderDataService {
  private httpClient = makeHttpClient();

  getAll() {
    return _unwrapAxiosResponse(this.httpClient.get(env.reminderUrl));
  }

  get(id: string) {
    return _unwrapAxiosResponse(
      this.httpClient.get(`${env.reminderUrl}/${id}`)
    );
  }
  update(id: string, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.put(`${env.reminderUrl}${id}/`, data)
    );
  }
  post(data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post(`${env.reminderUrl}`, data)
    );
  }
}

export default ReminderDataService;
